import {DateMapper} from "@app/core/shared/infrastructure/mappers/date.mapper";
import {MyOrderDetails} from "../../domain/dtos/my-order-details";
import {MyOrderItem} from "../../domain/dtos/my-order-item";
import {OrderDetailItemMapper} from "./order-detail-item.mapper";

export class OrderDetailsMapper {
    static deserialize(param: any): MyOrderDetails {
        const details: MyOrderItem[] = param.details.map(OrderDetailItemMapper.deserialize);
        return {
            statusCode: param.status,
            statusName: param.statusTitle,
            city: param.city,
            orderNumber: param.orderNumber,
            orderDate: DateMapper.deserialize(param.orderData),
            deliveryDate: DateMapper.deserialize(param.deliveryDate),
            orderImport: param.orderImport,
            orderTaxImport: param.orderTaxImport,
            orderTotalImport: param.orderTotalImport,
            details: details,
            customerName: param.customerName,
            deliveryAddress: param.deliveryAddress,
            postalCode: param.postalCode,
            couponName: param.couponName,
            couponImport: param.couponImport,
            //We calculate the totalPallets from all palletPrices
            totalPallets: details.reduce((accumulated, item) => {
                //If the item has a palletPrice we add it to the accumlated
                return item.palletPrice ? item.palletPrice + accumulated : accumulated
            }, 0)
        }
    }
}
